import { Suspense, lazy } from 'react'
import { useSearch } from './search-context-store'

/**
 * Mounts the command palette lazily — the heavy chunk (index builder +
 * UI) only loads the first time the user opens search, keeping it off
 * the initial bundle. Renders nothing until then.
 */
const CommandPalette = lazy(() =>
  import('./command-palette').then((m) => ({ default: m.CommandPalette })),
)

export function CommandPaletteMount() {
  const { isOpen } = useSearch()
  if (!isOpen) return null
  return (
    <Suspense fallback={null}>
      <CommandPalette />
    </Suspense>
  )
}
